import { render, staticRenderFns } from "./MdClearIcon.vue?vue&type=template&id=c31b08c6"
import script from "./MdClearIcon.vue?vue&type=script&lang=js"
export * from "./MdClearIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports